import { SiteConfig } from '../config';

const header = `
<div
id="BrightSpotHeader"
data-sothebys-component-url="${SiteConfig.bspHeaderUrl}"
/>
`;

const footer = `
<div
id="BrightSpotFooter"
data-sothebys-component-url="${SiteConfig.bspFooterUrl}"
/>
`;

function createNodeFromString(htmlString: string): ChildNode {
    const div = document.createElement('div');
    div.innerHTML = htmlString.trim();

    return div.firstChild;
}

export const injectBsp = function (): void {
    const body = document.getElementsByTagName('body')[0];
    body.prepend(createNodeFromString(header));
    body.append(createNodeFromString(footer));

    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', SiteConfig.bspScriptUrl);
    script.setAttribute('data-syndicated-url', SiteConfig.bspSyndicatedUrl);
    script.setAttribute('data-sothebys-component-loader', 'loader');
    body.appendChild(script);
};
